exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".personal___mV8Ut {\n  height: 100%;\n  background-color: #F7F7F7;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow-y: auto;\n}\n.personal___mV8Ut .list {\n  height: 48px;\n  border-bottom: 1px solid #E8E9EB;\n  display: -ms-flexbox;\n  display: flex;\n  background: #fff;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 16px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.personal___mV8Ut .info {\n  color: #68758E;\n}\n", ""]);

// exports
exports.locals = {
	"personal": "personal___mV8Ut"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/personalInfo/imageInfo/index.less
// module id = 1163
// module chunks = 0